import React from 'react';
import { CommonTextProps } from 'components/atoms/text/types/Props';

export default function Heading({ text, wrapText, styles }: CommonTextProps) {
  return <div className={`font-bold text-2xl sm:text-4xl ${wrapText ? '' : 'whitespace-pre'} ${styles}`}>{text}</div>;
}
